import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative py-12 md:py-20 overflow-hidden" data-id="element-72">
      {/* Decorative number */}
      <div className="absolute -top-4 right-0 font-display italic text-[140px] md:text-[220px] leading-none text-brand-teal/[0.06] select-none pointer-events-none" data-id="element-73">
        01
      </div>

      <div className="relative grid md:grid-cols-12 gap-8 items-end" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="md:col-span-8" data-id="element-75">
          <div className="flex items-center gap-2 mb-6" data-id="element-76">
            <span className="w-2 h-2 rounded-full bg-brand-mint animate-pulse" data-id="element-77" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-ink-muted" data-id="element-78">
              Now booking · Boston, MA
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-[-0.02em] mb-8 text-ink" data-id="element-79">
            Your team shouldn't waste hours on{' '}
            <span className="italic text-brand-teal" data-id="element-80">
              work software can do.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-ink-muted mb-8 max-w-2xl leading-relaxed" data-id="element-81">
            Manual processes, disconnected tools, and admin chaos are quietly
            costing you. We build automations and custom systems that take the
            busywork off your plate — and unlike outsourced shops, the result is
            fully yours.
          </p>

          <div className="flex flex-wrap gap-4 mb-8" data-id="element-82">
            <a href="/contact" className="inline-flex items-center gap-2 text-white font-semibold rounded-xl px-6 py-3.5 bg-gradient-to-r from-brand-deep to-brand-teal transition-all duration-200 hover:-translate-y-0.5 hover:shadow-hero" data-id="element-83">
              Tell us what's slowing you down
              <ArrowRight className="w-4 h-4" data-id="element-84" />
            </a>
            <a href="/services" className="text-ink border border-ink/15 rounded-xl px-6 py-3.5 hover:bg-ink/5 transition-colors font-semibold" data-id="element-85">
              See how we help
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-ink-muted" data-id="element-86">
            <span className="flex items-center gap-2" data-id="element-87">
              <span className="w-1 h-1 rounded-full bg-brand-teal" data-id="element-88" />
              Boston-based
            </span>
            <span className="flex items-center gap-2" data-id="element-89">
              <span className="w-1 h-1 rounded-full bg-brand-teal" data-id="element-90" />
              In-house engineers
            </span>
            <span className="flex items-center gap-2" data-id="element-91">
              <span className="w-1 h-1 rounded-full bg-brand-teal" data-id="element-92" />
              You own everything we build
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:col-span-4 space-y-6" data-id="element-93">
          <div className="relative rounded-2xl overflow-hidden border border-ink/10 shadow-card" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/o3tHyQGMYpVjg7ponzFLCx/iStock-995696638.jpg" alt="Boston skyline at sunset over the harbor" className="w-full h-64 md:h-72 object-cover" data-id="element-95" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-ink/10 to-transparent" data-id="element-96" />
            <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-97">
              <p className="font-display italic text-xl text-white leading-snug" data-id="element-98">
                Made in <span className="text-brand-mint" data-id="element-99">East Boston.</span>
              </p>
            </div>
          </div>

          <div className="bg-white border border-surface-border rounded-2xl p-6 shadow-card" data-id="element-100">
            <p className="font-display italic text-xl text-ink leading-snug mb-4" data-id="element-101">
              "They handed us the codebase, the keys, and a maintenance
              playbook. No one ever did that for us before."
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-surface-border" data-id="element-102">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-deep to-brand-teal" data-id="element-103" />
              <div data-id="element-104">
                <p className="text-sm font-semibold text-ink" data-id="element-105">
                  Operations Director
                </p>
                <p className="text-xs text-ink-muted" data-id="element-106">SMB, Greater Boston</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}